import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { CircularProgress } from "@mui/material";
import EditIcon from "../assets/editIcon.svg";
import { Switch } from "@mui/material";
import AddInvoice from "../assets/addDocumentsWhite.svg";
import WalletIcon from "../assets/walletIcon.svg";

import AddMore from "../assets/addMoreIcon.svg";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../utils/paginationUtils";
import "./ManageInvoice.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const ManageInvoice = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  return (
    <div className="manage-box bg-[#f7f7f7]">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Manage Invoice
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">Manage Invoice</div>
        <div className="flex gap-4 items-center">
          <div
            className="flex items-center gap-2 text-sm text-white bg-[#017C57] font-semibold uppercase px-5 py-2 rounded-full cursor-pointer"
            onClick={() => navigate("/dashboard/internal-user-management")}
          >
            <img src={WalletIcon} alt="wallet-icon" />
            Payment Details
          </div>
          <div
            className="flex items-center gap-2 text-sm text-white bg-[#017C57] font-semibold uppercase px-5 py-2 rounded-full cursor-pointer"
            onClick={() => navigate("/dashboard/manage-invoice/create-invoice")}
          >
            <img src={AddInvoice} alt="add-invoice-icon" />
            Create Invoice
          </div>
        </div>
      </div>

      <div className="flex item-center gap-4 ">
        <div
          className={`w-[180px] text-sm  font-semibold text-center py-1 cursor-pointer transition-all delay-150 duration-300 ease-in-out ${
            step === 1
              ? "text-[#017C57] border-0 border-b border-solid border-[#017C57]"
              : "text-[#797979]"
          }`}
          onClick={() => setStep(1)}
        >
          ALL INVOICE
        </div>
        <div
          className={`w-[180px] text-sm  font-semibold text-center py-1 cursor-pointer transition-all delay-150 duration-300 ease-in-out ${
            step === 2
              ? "text-[#017C57] border-0 border-b border-solid border-[#017C57]"
              : "text-[#797979]"
          }`}
          onClick={() => setStep(2)}
        >
          {" "}
          PENDING INVOICE
        </div>
        <div
          className={`w-[180px] text-sm  font-semibold text-center py-1 cursor-pointer transition-all delay-150 duration-300 ease-in-out ${
            step === 3
              ? "text-[#017C57] border-0 border-b border-solid border-[#017C57]"
              : "text-[#797979]"
          }`}
          onClick={() => setStep(3)}
        >
          {" "}
          UPCOMING INVOICE
        </div>
      </div>
      <hr
        style={{
          width: "100%",
          border: "1px solid rgba(228, 228, 228, 1)",
          marginBlock: "18px",
        }}
      />
      <div className="p-8 bg-white rounded-[16px]">
        <div className="grid grid-cols-9 ">
          <div className="text-sm font-semibold -tracking-[3%]">
            Invoice no.
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">
            Hospital Name
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">
            Phone Number
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">
            Invoice Date
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">
            Payment Date
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">
            Total Amount
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">Amount Due</div>
          <div className="text-sm font-semibold -tracking-[3%]">
            Invoice Status
          </div>
          <div className="text-sm font-semibold -tracking-[3%]">Actions</div>
        </div>
      </div>
    </div>
  );
};

export default ManageInvoice;
